import { render } from "./AuthWidth.vue?vue&type=template&id=5674f00c&scoped=true"
const script = {}

import "./AuthWidth.vue?vue&type=style&index=0&id=5674f00c&scoped=true&lang=css"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5674f00c"]])

export default __exports__